import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ToastsManager } from "ng2-toastr";
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { Company } from '../../../models/Company.model';
import { CompanyGroup } from '../../../models/CompanyGroup.model';
import { CompanyGroupSearch } from "../../../models/CompanyGroupSearch.model";
import { CompaniesService } from '../../../services/companies.service';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { Search } from '../../../models/Search.model';
import { GUARDS } from '../../../shared/auth/Roles';
import { IndustriesService } from '../../../services/industries.service';
import { Industry } from '../../../models/Industry.model';

@Component({
    selector: 'app-company-temporary',
    templateUrl: './company-temporary.component.html',
    styleUrls: ['./company-temporary.component.css']
})
export class CompanyTemporaryComponent implements OnInit {
    @ViewChild("closeModalCompanyTemporary") closeModalCompanyTemporary: ElementRef;
    loading: boolean;
    companyGroups: CompanyGroup[] = new Array<CompanyGroup>();
    companyGroupSearchModel: CompanyGroupSearch;
    companies: any[];
    companyTemporarySearch: Search = new Search();
    companyForm: FormGroup;
    industries: Industry[] = new Array<Industry>();
    commonHelper: CommonHelper = new CommonHelper();
    companyGroupAux: CompanyGroup = new CompanyGroup();
    companyTemporaryAux: any = null;
    email: String = '';
    currentDate: Date;

    canSave: Boolean = true;
    allowedRoles = [GUARDS.MANAGER, GUARDS.GOVERNANCE, GUARDS.BILLSRECEIVE];
    user;

    dropDownProducts: any;

    itemsPerPage: number[] = [10, 50, 100];
    totalItems: number = 5;
    currentPage: number = 1;

    constructor(private companiesService: CompaniesService,
        private formBuilder: FormBuilder,
        private router: Router,
        private industriesService: IndustriesService,
        private localStorage: LocalStorage,
        private tostr: ToastsManager) { }

    async ngOnInit() {
        this.loading = true;

        this.checkPermissions();

        await this.search(1);

        this.currentDate = new Date();
        this.companyGroupSearchModel = new CompanyGroupSearch();
        this.companyGroupSearchModel.allItems = true;
        this.industries = await this.industriesService.getAll();
        this.companyGroups = await this.companiesService.searchCompanyGroups(this.companyGroupSearchModel);

        this.loading = false;
    }

    checkPermissions() {
        this.user = this.localStorage.retrieve('user');
        if(!this.allowedRoles.includes(this.user.permission)) {
            this.canSave = false;
        }
    }

    async search(page?: number) {
        this.loading = true;
        this.currentPage = page ? page : 1;
        this.companyTemporarySearch.skip = (page - 1) * this.companyTemporarySearch.limit;
        this.industries = await this.industriesService.getAll();
        this.companies = await this.companiesService.searchTemporaryCompanies(this.companyTemporarySearch);
        this.totalItems = this.companyTemporarySearch.totalItems;
        this.localStorage.persist('companiesTemporary', this.companyTemporarySearch);
        this.loading = false;
    }

    async approvedCompany(){
        try {
            if(this.companyGroupAux._id != '' && this.companyGroupAux._id != undefined){
                this.companyGroupAux.name = this.companyGroups.find(x => x._id === this.companyGroupAux._id).name;
                this.companyTemporaryAux["companyGroup"] = { ...this.companyGroupAux };

                this.loading = true;
                let res = await this.companiesService.approvalTemporaryCompany(this.companyTemporaryAux);
                if(res._id){
                    this.loading = false;
                    this.tostr.success('Empresa aprovada e incluída no Financial');
                    this.closeModalCompanyTemporary.nativeElement.click();
                    await this.search(1);
                } else {
                    this.loading = false;
                    this.tostr.warning('Erro ao aprovar empresa');
                }

                this.companyTemporaryAux = null;
            }
        } catch (err){
            this.loading = false;
            console.log(err);
            this.tostr.warning('Erro ao aprovar empresa');
        }
    }

    clearGroup(){
        this.closeModalCompanyTemporary.nativeElement.click();
        this.companyGroupAux._id = '';
        this.companyGroupAux.name = '';
        this.companyTemporaryAux = null;
    }

    openModalCompanyTemporary(companyTemporary: any){
        this.companyTemporaryAux = {
            ...companyTemporary,
            expired: new Date(companyTemporary.expired)
        };
    }

    async renewExpirationDateCompanyTemporary(id: String) {
        this.closeModalCompanyTemporary.nativeElement.click();
        try{
            this.loading = true;
            let res = await this.companiesService.renewTemporaryCompany(id);
            if(res._id){
                this.loading = false;
                this.tostr.success('Data de expiração da empresa renovada');
                this.closeModalCompanyTemporary.nativeElement.click();
                await this.search(1);
            } else {
                this.loading = false;
                this.tostr.warning('Erro ao renovar data de expiração da empresa');
            }

            this.companyTemporaryAux = null;
        } catch(err) {
            this.loading = false;
            this.tostr.warning('Erro ao renovar data de expiração da empresa');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/companies/company-temporary/company-temporary.component.ts